import React from 'react';
import PropTypes from 'prop-types';

const Section = ({ id, className, children }) => {
  return (
    <section className={className} id={id}>
      {children}
    </section>
  );
};

Section.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

Section.defaultProps = {
  id: "",
  className: ""
};

export default Section;